module.exports = __webpack_public_path__ + "static/img/club-portal-tit.6425889.png";